/* @ngInject */
export const TubeHousingFactory = (EquipmentType, Location, Room, Manufacturer, EquipmentModel) => {
    return function TubeHousing() {
        this.id = null;
        this.type = new EquipmentType();
        this.manufacturer = new Manufacturer();
        this.name = null;
        this.serial = null;
        this.description = null;
        this.room = new Room();
        this.department = new Location();
        this.model = new EquipmentModel();
    };
};
